import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { createLead } from '@/services/api';

export const AgentContactCard = ({ agent }) => {
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: `I'd like to get in touch with ${agent.name}.`,
    company: '',
  });

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast('Please add your name and email');
      return;
    }
    setSubmitting(true);
    try {
      await createLead({
        full_name: form.name,
        email: form.email,
        phone: form.phone,
        message: form.message,
        lead_type: 'contact',
        agent_ref: agent.ref,
        agent_name: agent.name,
        listing_mls_number: null,
        company: form.company || '',
      });
      toast('Message sent', { description: "We'll be in touch shortly." });
      setForm((f) => ({ ...f, message: '' }));
    } catch {
      try {
        await createLead({
          full_name: form.name,
          email: form.email,
          phone: form.phone,
          message: `[Agent: ${agent.name}]\n${form.message}`,
          lead_type: 'contact',
          listing_mls_number: null,
          company: form.company || '',
        });
        toast('Message sent', { description: "We'll be in touch shortly." });
        setForm((f) => ({ ...f, message: '' }));
      } catch {
        toast.error('Something went wrong, please try again.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="sticky top-24 rounded-2xl border border-slate-200 bg-white p-5 shadow-md">
      <h2 className="mb-4 text-base font-semibold text-slate-900">Contact {agent.name}</h2>
      <form onSubmit={submit} className="space-y-3">
        <div>
          <Label htmlFor="ac-name" className="sr-only">Name</Label>
          <Input
            id="ac-name"
            placeholder="Full name"
            value={form.name}
            onChange={set('name')}
            className="rounded-xl"
          />
        </div>
        <div>
          <Label htmlFor="ac-email" className="sr-only">Email</Label>
          <Input
            id="ac-email"
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={set('email')}
            className="rounded-xl"
          />
        </div>
        <div>
          <Label htmlFor="ac-phone" className="sr-only">Phone</Label>
          <Input
            id="ac-phone"
            placeholder="Phone (optional)"
            value={form.phone}
            onChange={set('phone')}
            className="rounded-xl"
          />
        </div>
        <div>
          <Label htmlFor="ac-msg" className="sr-only">Message</Label>
          <Textarea
            id="ac-msg"
            rows={3}
            value={form.message}
            onChange={set('message')}
            className="rounded-xl"
          />
        </div>
        {/* Honeypot — bots fill this, humans don't */}
        <div
          style={{ position: 'absolute', left: '-9999px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden' }}
          aria-hidden="true"
        >
          <input tabIndex={-1} autoComplete="off" value={form.company} onChange={set('company')} />
        </div>
        <Button type="submit" className="w-full rounded-xl" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send message'}
        </Button>
      </form>
    </div>
  );
};
